import { render, staticRenderFns } from "./PorletLink.vue?vue&type=template&id=0170dce0"
import script from "./PorletLink.vue?vue&type=script&lang=js"
export * from "./PorletLink.vue?vue&type=script&lang=js"
import style0 from "./PorletLink.vue?vue&type=style&index=0&id=0170dce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports